var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.4,10V9.1c0-0.5,0.3-0.9,0.8-1.2s1.2-0.5,2-0.5c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0.1C5,7.7,4.9,7.9,4.9,8.2 C4.8,8.4,4.8,8.7,4.8,8.9v1H1.4V10z M5.9,10V9c0-0.3,0.1-0.6,0.3-0.9C6.4,7.8,6.6,7.6,7,7.4C7.4,7.2,7.8,7,8.3,6.9S9.4,6.8,10,6.8 s1.2,0,1.7,0.1s0.9,0.3,1.3,0.5c0.4,0.2,0.6,0.4,0.8,0.7C14,8.3,14.1,8.6,14.1,9v1H5.9z M15.2,10V9c0-0.3,0-0.5-0.1-0.8 C15,8,14.9,7.7,14.8,7.5c0.1,0,0.3,0,0.4-0.1c0.1,0,0.3,0,0.5,0c0.8,0,1.5,0.2,2,0.5c0.5,0.3,0.8,0.7,0.8,1.2V10 C18.6,10,15.2,10,15.2,10z M4.2,6.4C3.9,6.4,3.6,6.3,3.3,6S3,5.5,3,5.1c0-0.3,0.1-0.6,0.4-0.9C3.6,4,3.9,3.9,4.2,3.9 c0.3,0,0.6,0.1,0.9,0.4c0.2,0.2,0.4,0.5,0.4,0.9c0,0.3-0.1,0.6-0.4,0.9C4.9,6.3,4.6,6.4,4.2,6.4z M15.8,6.4c-0.3,0-0.6-0.1-0.9-0.4 c-0.2-0.2-0.4-0.5-0.4-0.9c0-0.3,0.1-0.6,0.4-0.9c0.2-0.2,0.5-0.4,0.9-0.4c0.3,0,0.6,0.1,0.9,0.4c0.2,0.2,0.4,0.5,0.4,0.9 S17,5.7,16.7,6C16.4,6.3,16.1,6.4,15.8,6.4z M10,5.8c-0.5,0-1-0.2-1.4-0.6C8.3,4.9,8.1,4.4,8.1,3.9s0.2-1,0.6-1.4C9,2.2,9.5,2,10,2 s1,0.2,1.4,0.6S12,3.4,12,4c0,0.5-0.2,1-0.6,1.4C11,5.6,10.5,5.8,10,5.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,15.2h1h3.1v0.6v0.6l0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1s0.5-0.3,1.4-0.9c0.7-0.5,1.3-0.9,1.3-1 c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0-0.6-0.5-1.3-1c-1.1-0.8-1.3-0.9-1.4-0.9s-0.1,0-0.2,0.1s-0.1,0.1-0.1,0.7V14H2.4h-1 L1.5,15.2L1.5,15.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,14h-1h-3.1v-0.6v-0.6l-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.5,0.3-1.4,0.9c-0.7,0.5-1.3,0.9-1.3,1 c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0,0.6,0.5,1.3,1c1.1,0.8,1.3,0.9,1.4,0.9c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.7v-0.6 h3.1h1V14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegroup);
export default __webpack_public_path__ + "static/media/regroup.5db8f7c57c5480653cfe70c547825b71.svg";
export { ForwardRef as ReactComponent };